/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { SwiperWrap, TitleWrap } from '@styles/base.style'
import { BackBtn } from '@styles/button.style'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import useRootStore from '@store/useRootStore'
import { Swiper } from 'swiper/react/swiper-react'
import _ from 'lodash'
import { AdvButton } from '@components/Button'
import { CommentsIco, LikeIco } from '@shared/Icon/EtcIcon'
import { PremiumPickItem } from '@views/Home/index.style'
import PickNoticeIco from '@shared/Icon/EtcIcon/PickNoticeIco'
import { useOnMount } from '@utils/reactExt'
import { appScrollTo, loadOrReload, toShortNumber } from '@utils/utils'
import classNames from 'classnames'

let fetchCompanyPickManagersTimer = null

const CompanyPickManagerList: React.FC = observer(() => {
  const { routerStore, globalStore, companyPickStore, logStore } = useRootStore()
  const { companyPickManagers } = companyPickStore

  // img
  const imageUrl = globalStore.getIngameImagesUrl()
  const IMAGE_DEFAULT_URL = `${imageUrl}bg/default_img.jpg`

  useOnMount(() => {
    clearTimeout(fetchCompanyPickManagersTimer)
    fetchCompanyPickManagersTimer = setTimeout(() => {
      companyPickStore.fetchCompanyPickManagers({}).catch(err => console.error(err))
    }, 150)

    if (isMobile) {
      appScrollTo(1)
    }
  })

  const slides = _.map(companyPickManagers, (manager) => {
    const onLoadPage = () => {
      switch (manager.userNick) {
        case '고정배':
          logStore.writeButtonLog({ pageId: 'a070', buttonId: '001' }).catch(console.error)
          break
        case '될놈될이다':
          logStore.writeButtonLog({ pageId: 'a070', buttonId: '002' }).catch(console.error)
          break
        case '프로키':
          logStore.writeButtonLog({ pageId: 'a070', buttonId: '003' }).catch(console.error)
          break
      }

      companyPickStore.setSelectedCompanyPickManager(manager)
      if (isMobile) {
        loadOrReload(`/today-pick-detail`)
      } else {
        globalStore.setVisibleTodayPick(true)
        globalStore.setVisibleAdvNews(false)
        globalStore.setVisibleGuide(false)
        globalStore.setVisibleUserPick(false)
        globalStore.setVisibleTodayPickList(false)
      }
    }

    const characterImgClassName = classNames('character-img', {
      'prokey': manager.userNick === '프로키',
    })

    const contents = (
      <PremiumPickItem>
        <div className="character-info-wrap">
          <div className="character-bg-wrap">
            <img src={manager.listPageBackgroundImageUrl || IMAGE_DEFAULT_URL}
                 alt={manager.listPageBackgroundImageUrl} className="character-bg-img"/>
          </div>
          <img src={manager.listPageCharacterImageUrl || IMAGE_DEFAULT_URL}
               alt={manager.listPageCharacterImageUrl} className={characterImgClassName}/>
          <ul className="total-count">
            <li className="total-count-list">
              <LikeIco/>
              <span className="num">{toShortNumber(manager.likeCount)}</span>
            </li>
            <li className="total-count-list">
              <CommentsIco/>
              <span className="num">{toShortNumber(manager.commentCount)}</span>
            </li>
          </ul>
        </div>

        <div className="analyst-info-wrap">
          <p className="nick-name">{manager.userNick}</p>
          {!_.isEmpty(manager.notice) &&
            <div className="notice">
              <PickNoticeIco/>
              <span className="txt">{manager.notice}</span>
            </div>
          }
        </div>

      </PremiumPickItem>
    )
    const button = (
      <AdvButton
        width={'100%'}
        contents={contents}
        className="pick-item"
        onClick={onLoadPage}
      />
    )
    return (
      <div className="swipe-item">
        {button}
      </div>
    )
  })

  const TodayPickListContents = (
    <SwiperWrap className="p-18 scroll-view">
      <Swiper
        shortSwipes
        initialSlide={0}
        loop={false}
        spaceBetween={14}
      >
        {slides}
      </Swiper>
    </SwiperWrap>
  )

  return (
    <Fragment>
      <TitleWrap className={isMobile ? 'title-wrap' : 'adv-hidden'}>
        <BackBtn onClick={() => routerStore.goBack()}>
          <ArrowIco/>
        </BackBtn>
      </TitleWrap>
      {TodayPickListContents}
    </Fragment>
  )
})

export default CompanyPickManagerList
